module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "introduction"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Ah yes, the music of the 60s and 70s and a few from the 80s. From the alphabetical list of Aerosmith and AC/DC to Zeppelin and ZZ Top, rock music had created a culture that has not or will never be seen again. So many changes in culture have developed from those years. Hair styles, clothes styles, the drug culture, the sexual revolution, and Rock and Roll like it has never been played since. It was a fun time back then; it still can be now. Put your favourite band on while you cook in Rock and Roll Heaven. I have also included a suggested YouTube song for each recipe. Keep on cookin’ and rockin’ folks. Old rock stars and their fans never die; they just look like they did. What do you think keeps ’em going all these years? Good Food. Enjoy and have fun.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.84285in",
      "height": "3.22917in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A crowd of people at a concert Description automatically generated with medium confidence")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 78
// module chunks = 0